(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809],{

/***/ 60190:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share-subscription",
      function () {
        return __webpack_require__(74876);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ share_subscription; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./src/utils/currency-format.ts
var currency_format = __webpack_require__(83384);
;// CONCATENATED MODULE: ./src/components/stripe/PricingPlanExternal.tsx









var PricingPlanExternal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var cta = props.cta, description = props.description, icon = props.icon, features = props.features, name = props.name, popular = props.popular, price = props.price, disabled = props.disabled, yearlyPayment = props.yearlyPayment, priceDescription = props.priceDescription, featuresTitle = props.featuresTitle, chipLabel = props.chipLabel, previousPrice = props.previousPrice, bestPrice = props.bestPrice, sx = props.sx, other = (0,_object_without_properties/* default */.Z)(props, [
        "cta",
        "description",
        "icon",
        "features",
        "name",
        "popular",
        "price",
        "disabled",
        "yearlyPayment",
        "priceDescription",
        "featuresTitle",
        "chipLabel",
        "previousPrice",
        "bestPrice",
        "sx"
    ]);
    var subscriptionValue = Number(price);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                backgroundColor: bestPrice ? "#29A776" : "inherit",
                p: bestPrice ? "0.5rem" : "4rem 0.5rem 0.5rem",
                borderRadius: 1,
                height: "100%"
            },
            children: [
                bestPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        color: "#FFF",
                        textAlign: "center",
                        fontWeight: 700,
                        mb: 1,
                        mt: 0.5
                    },
                    children: t("pricing_table__general__labels__best_price")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    sx: (0,_object_spread/* default */.Z)({
                        display: "flex",
                        flexDirection: "column",
                        border: !bestPrice ? "0.5px solid #f5f5f5" : "none"
                    }, sx)
                }, other), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mb: !previousPrice ? "3.2rem" : "innerit"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                mt: 2
                                            },
                                            variant: "h6",
                                            children: name
                                        }),
                                        chipLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            sx: {
                                                color: "#FFF",
                                                fontWeight: 700,
                                                fontSize: 16,
                                                "&.MuiChip-filledDefault": {
                                                    backgroundColor: "#ffae00"
                                                }
                                            },
                                            label: chipLabel,
                                            size: "medium"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        textDecoration: "line-through"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            children: previousPrice !== null && (0,currency_format/* default */.ZP)(Number(previousPrice).toString(), currency_format/* currencyFormatMap.SE */.qD.SE)
                                        }),
                                        previousPrice !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "text.secondary",
                                            sx: {
                                                alignSelf: "flex-end",
                                                ml: 1
                                            },
                                            variant: "body2",
                                            children: t("pricing_table__general__labels__plan_recurrency")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h4",
                                            children: price !== null ? price === 0 ? t("pricing_table__general__labels__free_tier_value") : (0,currency_format/* default */.ZP)(Number(subscriptionValue).toString(), currency_format/* currencyFormatMap.SE */.qD.SE) : t("pricing_table__general__labels__comming_soon")
                                        }),
                                        price !== null && price !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "text.secondary",
                                            sx: {
                                                alignSelf: "flex-end",
                                                ml: 1
                                            },
                                            variant: "subtitle2",
                                            children: t("pricing_table__general__labels__plan_recurrency")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.secondary",
                                    sx: {
                                        mt: 0,
                                        mb: !priceDescription ? "2.2rem" : "innerit"
                                    },
                                    variant: "body2",
                                    children: price !== null ? priceDescription : " "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.secondary",
                                    sx: {
                                        mt: price !== null ? 2 : 5,
                                        fontWeight: 600
                                    },
                                    variant: "body2",
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1,
                                p: 3,
                                minHeight: "32rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 2,
                                sx: {
                                    flexGrow: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        alignItems: "center",
                                        direction: "row",
                                        spacing: 1,
                                        sx: {
                                            alignItems: "center",
                                            display: "flex"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontWeight: 700
                                            },
                                            variant: "body2",
                                            children: featuresTitle
                                        })
                                    }),
                                    features.map(function(feature, i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            alignItems: "center",
                                            direction: "row",
                                            spacing: 1,
                                            sx: {
                                                alignItems: "center",
                                                display: "flex"
                                            },
                                            children: [
                                                (feature === null || feature === void 0 ? void 0 : feature.include) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                                    color: "success",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                                    color: "error",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        fontWeight: 500
                                                    },
                                                    variant: "body2",
                                                    children: feature === null || feature === void 0 ? void 0 : feature.describe
                                                })
                                            ]
                                        }, "".concat(feature.describe, "-").concat(i));
                                    })
                                ]
                            })
                        })
                    ]
                }))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/share-subscription/index.tsx






var ShareSubscription = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var userFlags = (0,es/* useSelector */.v9)(function(store) {
        return store;
    }).userFlags;
    var plans = [
        {
            cta: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "free" ? t("pricing_table__general__subscription_state_label__current_plan") : t("pricing_table__general__subscription_state_label__higher_plan"),
            name: t("pricing_table__general__name__enterprise"),
            description: t("pricing_table__plans__starter_plan__description"),
            priceDescription: t("pricing_table__plans__starter_plan__price_subtitle"),
            featuresTitle: t("pricing_table__features__title"),
            previousPrice: null,
            features: [
                {
                    describe: t("pricing_table__features__options__item_1"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_2"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_3"),
                    include: true
                }, 
            ],
            disabled: true,
            price: 0,
            payment: null,
            bestPrice: false
        },
        {
            cta: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "pro" ? t("pricing_table__general__subscription_state_label__current_plan") : t("pricing_table__general__subscription_state_label__get_pro_plan"),
            name: t("pricing_table__general__name__pro"),
            chipLabel: t("pricing_table__general__labels__discount_label", {
                discountAmount: 63
            }),
            description: t("pricing_table__plans__pro_plan__description"),
            priceDescription: t("pricing_table__plans__pro_plan__price_subtitle"),
            featuresTitle: t("pricing_table__features__title"),
            features: [
                {
                    describe: t("pricing_table__features__options__item_7"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_15"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_9"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_10"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_16"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_18"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_19"),
                    include: true
                }, 
            ],
            previousPrice: 1199,
            price: 449,
            popular: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "premium" || (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "pro" ? false : true,
            disabled: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "premium" || (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "pro" ? true : false,
            payment: "annually",
            bestPrice: true
        },
        {
            cta: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "premium" ? t("pricing_table__general__subscription_state_label__current_plan") : (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "pro" ? t("pricing_table__general__subscription_state_label__higher_plan") : t("pricing_table__general__subscription_state_label__get_premium_plan"),
            name: t("pricing_table__general__name__premium"),
            chipLabel: t("pricing_table__general__labels__discount_label", {
                discountAmount: 38
            }),
            description: t("pricing_table__plans__premium_plan__description"),
            priceDescription: t("pricing_table__plans__premium_plan__price_subtitle"),
            featuresTitle: t("pricing_table__features__title"),
            features: [
                {
                    describe: t("pricing_table__features__options__item_7"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_8"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_9"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_10"),
                    include: true
                },
                {
                    describe: t("pricing_table__features__options__item_11"),
                    include: true
                }, 
            ],
            previousPrice: 1199,
            price: 749,
            payment: "quarterly",
            bestPrice: false,
            disabled: (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "premium" || (userFlags === null || userFlags === void 0 ? void 0 : userFlags.tier) === "pro" ? true : false
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Parsly"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "main",
                sx: {
                    flexGrow: 1,
                    py: 8,
                    backgroundColor: "#FFF"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    id: "pricing-plan-external",
                    maxWidth: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    mb: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.secondary",
                                    sx: {
                                        my: 2
                                    },
                                    variant: "body1",
                                    children: t("pricing_table__general__labels__page_description")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 2,
                                children: plans.map(function(plan) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 4,
                                        sx: {
                                            height: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingPlanExternal, {
                                            cta: plan === null || plan === void 0 ? void 0 : plan.cta,
                                            icon: null,
                                            description: plan === null || plan === void 0 ? void 0 : plan.description,
                                            features: plan === null || plan === void 0 ? void 0 : plan.features,
                                            name: plan === null || plan === void 0 ? void 0 : plan.name,
                                            price: plan === null || plan === void 0 ? void 0 : plan.price,
                                            yearlyPayment: plan.payment,
                                            disabled: (plan === null || plan === void 0 ? void 0 : plan.disabled) ? true : false,
                                            popular: (plan === null || plan === void 0 ? void 0 : plan.popular) ? true : false,
                                            priceDescription: plan === null || plan === void 0 ? void 0 : plan.priceDescription,
                                            featuresTitle: plan === null || plan === void 0 ? void 0 : plan.featuresTitle,
                                            previousPrice: plan === null || plan === void 0 ? void 0 : plan.previousPrice,
                                            chipLabel: plan === null || plan === void 0 ? void 0 : plan.chipLabel,
                                            bestPrice: plan === null || plan === void 0 ? void 0 : plan.bestPrice,
                                            sx: {
                                                height: "100%",
                                                //maxWidth: 460,
                                                mx: "auto"
                                            }
                                        })
                                    }, plan === null || plan === void 0 ? void 0 : plan.name);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var share_subscription = (ShareSubscription);


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qD": function() { return /* binding */ currencyFormatMap; }
/* harmony export */ });
/* unused harmony export currencyMap */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52875);
/* harmony import */ var _public_countries_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89193);




var CurrencyFormat = function(value, formatProps) {
    return formatProps && parseFloat(value).toLocaleString(formatProps.locale, {
        style: "currency",
        currency: formatProps.currency
    });
};
var currencyMap = {
    SE: "SEK",
    US: "USD"
};
var currencies = _public_countries_json__WEBPACK_IMPORTED_MODULE_0__.reduce(function(a, v) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, v.code, {
        locale: "en-US",
        currency: "USD"
    }));
}, {});
var currencyFormatMap = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, currencies), {
    SE: {
        locale: "sv-SE",
        currency: "SEK"
    },
    US: {
        locale: "en-US",
        currency: "USD"
    }
});
/* harmony default export */ __webpack_exports__["ZP"] = (CurrencyFormat);


/***/ }),

/***/ 89193:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"name":"Afghanistan","code":"AF"},{"name":"Åland Islands","code":"AX"},{"name":"Albania","code":"AL"},{"name":"Algeria","code":"DZ"},{"name":"American Samoa","code":"AS"},{"name":"AndorrA","code":"AD"},{"name":"Angola","code":"AO"},{"name":"Anguilla","code":"AI"},{"name":"Antarctica","code":"AQ"},{"name":"Antigua and Barbuda","code":"AG"},{"name":"Argentina","code":"AR"},{"name":"Armenia","code":"AM"},{"name":"Aruba","code":"AW"},{"name":"Australia","code":"AU"},{"name":"Austria","code":"AT"},{"name":"Azerbaijan","code":"AZ"},{"name":"Bahamas","code":"BS"},{"name":"Bahrain","code":"BH"},{"name":"Bangladesh","code":"BD"},{"name":"Barbados","code":"BB"},{"name":"Belarus","code":"BY"},{"name":"Belgium","code":"BE"},{"name":"Belize","code":"BZ"},{"name":"Benin","code":"BJ"},{"name":"Bermuda","code":"BM"},{"name":"Bhutan","code":"BT"},{"name":"Bolivia","code":"BO"},{"name":"Bosnia and Herzegovina","code":"BA"},{"name":"Botswana","code":"BW"},{"name":"Bouvet Island","code":"BV"},{"name":"Brazil","code":"BR"},{"name":"British Indian Ocean Territory","code":"IO"},{"name":"Brunei Darussalam","code":"BN"},{"name":"Bulgaria","code":"BG"},{"name":"Burkina Faso","code":"BF"},{"name":"Burundi","code":"BI"},{"name":"Cambodia","code":"KH"},{"name":"Cameroon","code":"CM"},{"name":"Canada","code":"CA"},{"name":"Cape Verde","code":"CV"},{"name":"Cayman Islands","code":"KY"},{"name":"Central African Republic","code":"CF"},{"name":"Chad","code":"TD"},{"name":"Chile","code":"CL"},{"name":"China","code":"CN"},{"name":"Christmas Island","code":"CX"},{"name":"Cocos (Keeling) Islands","code":"CC"},{"name":"Colombia","code":"CO"},{"name":"Comoros","code":"KM"},{"name":"Congo","code":"CG"},{"name":"Congo, The Democratic Republic of the","code":"CD"},{"name":"Cook Islands","code":"CK"},{"name":"Costa Rica","code":"CR"},{"name":"Cote D\\"Ivoire","code":"CI"},{"name":"Croatia","code":"HR"},{"name":"Cuba","code":"CU"},{"name":"Cyprus","code":"CY"},{"name":"Czech Republic","code":"CZ"},{"name":"Denmark","code":"DK"},{"name":"Djibouti","code":"DJ"},{"name":"Dominica","code":"DM"},{"name":"Dominican Republic","code":"DO"},{"name":"Ecuador","code":"EC"},{"name":"Egypt","code":"EG"},{"name":"El Salvador","code":"SV"},{"name":"Equatorial Guinea","code":"GQ"},{"name":"Eritrea","code":"ER"},{"name":"Estonia","code":"EE"},{"name":"Ethiopia","code":"ET"},{"name":"Falkland Islands (Malvinas)","code":"FK"},{"name":"Faroe Islands","code":"FO"},{"name":"Fiji","code":"FJ"},{"name":"Finland","code":"FI"},{"name":"France","code":"FR"},{"name":"French Guiana","code":"GF"},{"name":"French Polynesia","code":"PF"},{"name":"French Southern Territories","code":"TF"},{"name":"Gabon","code":"GA"},{"name":"Gambia","code":"GM"},{"name":"Georgia","code":"GE"},{"name":"Germany","code":"DE"},{"name":"Ghana","code":"GH"},{"name":"Gibraltar","code":"GI"},{"name":"Greece","code":"GR"},{"name":"Greenland","code":"GL"},{"name":"Grenada","code":"GD"},{"name":"Guadeloupe","code":"GP"},{"name":"Guam","code":"GU"},{"name":"Guatemala","code":"GT"},{"name":"Guernsey","code":"GG"},{"name":"Guinea","code":"GN"},{"name":"Guinea-Bissau","code":"GW"},{"name":"Guyana","code":"GY"},{"name":"Haiti","code":"HT"},{"name":"Heard Island and Mcdonald Islands","code":"HM"},{"name":"Holy See (Vatican City State)","code":"VA"},{"name":"Honduras","code":"HN"},{"name":"Hong Kong","code":"HK"},{"name":"Hungary","code":"HU"},{"name":"Iceland","code":"IS"},{"name":"India","code":"IN"},{"name":"Indonesia","code":"ID"},{"name":"Iran, Islamic Republic Of","code":"IR"},{"name":"Iraq","code":"IQ"},{"name":"Ireland","code":"IE"},{"name":"Isle of Man","code":"IM"},{"name":"Israel","code":"IL"},{"name":"Italy","code":"IT"},{"name":"Jamaica","code":"JM"},{"name":"Japan","code":"JP"},{"name":"Jersey","code":"JE"},{"name":"Jordan","code":"JO"},{"name":"Kazakhstan","code":"KZ"},{"name":"Kenya","code":"KE"},{"name":"Kiribati","code":"KI"},{"name":"Korea, Democratic People\\"S Republic of","code":"KP"},{"name":"Korea, Republic of","code":"KR"},{"name":"Kuwait","code":"KW"},{"name":"Kyrgyzstan","code":"KG"},{"name":"Lao People\\"S Democratic Republic","code":"LA"},{"name":"Latvia","code":"LV"},{"name":"Lebanon","code":"LB"},{"name":"Lesotho","code":"LS"},{"name":"Liberia","code":"LR"},{"name":"Libyan Arab Jamahiriya","code":"LY"},{"name":"Liechtenstein","code":"LI"},{"name":"Lithuania","code":"LT"},{"name":"Luxembourg","code":"LU"},{"name":"Macao","code":"MO"},{"name":"Macedonia, The Former Yugoslav Republic of","code":"MK"},{"name":"Madagascar","code":"MG"},{"name":"Malawi","code":"MW"},{"name":"Malaysia","code":"MY"},{"name":"Maldives","code":"MV"},{"name":"Mali","code":"ML"},{"name":"Malta","code":"MT"},{"name":"Marshall Islands","code":"MH"},{"name":"Martinique","code":"MQ"},{"name":"Mauritania","code":"MR"},{"name":"Mauritius","code":"MU"},{"name":"Mayotte","code":"YT"},{"name":"Mexico","code":"MX"},{"name":"Micronesia, Federated States of","code":"FM"},{"name":"Moldova, Republic of","code":"MD"},{"name":"Monaco","code":"MC"},{"name":"Mongolia","code":"MN"},{"name":"Montserrat","code":"MS"},{"name":"Morocco","code":"MA"},{"name":"Mozambique","code":"MZ"},{"name":"Myanmar","code":"MM"},{"name":"Namibia","code":"NA"},{"name":"Nauru","code":"NR"},{"name":"Nepal","code":"NP"},{"name":"Netherlands","code":"NL"},{"name":"Netherlands Antilles","code":"AN"},{"name":"New Caledonia","code":"NC"},{"name":"New Zealand","code":"NZ"},{"name":"Nicaragua","code":"NI"},{"name":"Niger","code":"NE"},{"name":"Nigeria","code":"NG"},{"name":"Niue","code":"NU"},{"name":"Norfolk Island","code":"NF"},{"name":"Northern Mariana Islands","code":"MP"},{"name":"Norway","code":"NO"},{"name":"Oman","code":"OM"},{"name":"Pakistan","code":"PK"},{"name":"Palau","code":"PW"},{"name":"Palestinian Territory, Occupied","code":"PS"},{"name":"Panama","code":"PA"},{"name":"Papua New Guinea","code":"PG"},{"name":"Paraguay","code":"PY"},{"name":"Peru","code":"PE"},{"name":"Philippines","code":"PH"},{"name":"Pitcairn","code":"PN"},{"name":"Poland","code":"PL"},{"name":"Portugal","code":"PT"},{"name":"Puerto Rico","code":"PR"},{"name":"Qatar","code":"QA"},{"name":"Reunion","code":"RE"},{"name":"Romania","code":"RO"},{"name":"Russian Federation","code":"RU"},{"name":"RWANDA","code":"RW"},{"name":"Saint Helena","code":"SH"},{"name":"Saint Kitts and Nevis","code":"KN"},{"name":"Saint Lucia","code":"LC"},{"name":"Saint Pierre and Miquelon","code":"PM"},{"name":"Saint Vincent and the Grenadines","code":"VC"},{"name":"Samoa","code":"WS"},{"name":"San Marino","code":"SM"},{"name":"Sao Tome and Principe","code":"ST"},{"name":"Saudi Arabia","code":"SA"},{"name":"Senegal","code":"SN"},{"name":"Serbia and Montenegro","code":"CS"},{"name":"Seychelles","code":"SC"},{"name":"Sierra Leone","code":"SL"},{"name":"Singapore","code":"SG"},{"name":"Slovakia","code":"SK"},{"name":"Slovenia","code":"SI"},{"name":"Solomon Islands","code":"SB"},{"name":"Somalia","code":"SO"},{"name":"South Africa","code":"ZA"},{"name":"South Georgia and the South Sandwich Islands","code":"GS"},{"name":"Spain","code":"ES"},{"name":"Sri Lanka","code":"LK"},{"name":"Sudan","code":"SD"},{"name":"Suriname","code":"SR"},{"name":"Svalbard and Jan Mayen","code":"SJ"},{"name":"Swaziland","code":"SZ"},{"name":"Sweden","code":"SE"},{"name":"Switzerland","code":"CH"},{"name":"Syrian Arab Republic","code":"SY"},{"name":"Taiwan, Province of China","code":"TW"},{"name":"Tajikistan","code":"TJ"},{"name":"Tanzania, United Republic of","code":"TZ"},{"name":"Thailand","code":"TH"},{"name":"Timor-Leste","code":"TL"},{"name":"Togo","code":"TG"},{"name":"Tokelau","code":"TK"},{"name":"Tonga","code":"TO"},{"name":"Trinidad and Tobago","code":"TT"},{"name":"Tunisia","code":"TN"},{"name":"Turkey","code":"TR"},{"name":"Turkmenistan","code":"TM"},{"name":"Turks and Caicos Islands","code":"TC"},{"name":"Tuvalu","code":"TV"},{"name":"Uganda","code":"UG"},{"name":"Ukraine","code":"UA"},{"name":"United Arab Emirates","code":"AE"},{"name":"United Kingdom","code":"GB"},{"name":"United States","code":"US"},{"name":"United States Minor Outlying Islands","code":"UM"},{"name":"Uruguay","code":"UY"},{"name":"Uzbekistan","code":"UZ"},{"name":"Vanuatu","code":"VU"},{"name":"Venezuela","code":"VE"},{"name":"Viet Nam","code":"VN"},{"name":"Virgin Islands, British","code":"VG"},{"name":"Virgin Islands, U.S.","code":"VI"},{"name":"Wallis and Futuna","code":"WF"},{"name":"Western Sahara","code":"EH"},{"name":"Yemen","code":"YE"},{"name":"Zambia","code":"ZM"},{"name":"Zimbabwe","code":"ZW"}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2066,1148,6886,7918,1179,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(60190); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);